import getConfig from 'next/config';
import URL from 'url-parse';

import {ContentType} from '~/src/utilities/constants/types';
import {getContentUrl} from './link';

const {publicRuntimeConfig: config} = getConfig();

interface Content {
    id: number;
    type: string;
    content: {
        meta: {
            urlSlug: string;
        };
    };
}

export const hasAmp = (data: Content) => {
    switch (data.type) {
        case ContentType.ARTICLE:
        case ContentType.BREAKINGNEWS:
        case ContentType.LIFESTYLE:
        case ContentType.VIDEO:
            return true;
        default:
            return false;
    }
};

export const getAmpUrl = (data: Content) => {
    return new URL(getContentUrl(`/story/${data.content.meta.urlSlug}-${data.id}`), config.ampBaseUrl).href;
};
